import { render } from "./TextAlertModal.vue?vue&type=template&id=23f80b68"
import script from "./TextAlertModal.vue?vue&type=script&lang=js"
export * from "./TextAlertModal.vue?vue&type=script&lang=js"

import "./TextAlertModal.vue?vue&type=style&index=0&id=23f80b68&lang=css"

import exportComponent from "C:\\Users\\USER\\Documents\\D_A\\Lockers\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__